import {
  IMatch,
  IResponseShort,
  IBaseMatchData,
  TMatchData,
  IUpdateCheckoutDatePayload,
  TReview,
  TBaseReview,
  ISavedSearchPreference,
  ISearchPreferencePayload,
  PaymentStatusStripe
} from "interfaces/interfaces";
import { ServiceApi } from "../utils/utilAmplify";
import query from "../utils/query";
import { ServiceName } from "../config/amplify";

class StudentAPIClass {
  private readonly api: ServiceApi;

  constructor() {
    this.api = new ServiceApi(ServiceName.Protected);
  }

  getMatches(userId: string): Promise<TMatchData[]> {
    return this.api.get(`matches/student-matches/${userId}`);
  }
  acceptInvite(payload: IBaseMatchData): Promise<IResponseShort> {
    return this.api.post("matches/accept-invite", payload);
  }
  rejectInvite(payload: IBaseMatchData): Promise<IResponseShort> {
    return this.api.post("matches/reject-invite", payload);
  }
  getMatch(
    studentId: string,
    hostId: string,
    houseId: string,
    options?: { showNotificationOnError?: boolean }
  ): Promise<IMatch> {
    return this.api
      .get(
        "matches/details?" +
          query.stringify({
            student_id: studentId,
            host_id: hostId,
            house_id: houseId
          }),
        options
      )
      .then((res) => res.data);
  }
  showInterest(
    payload: IBaseMatchData,
    message: string
  ): Promise<IResponseShort> {
    return this.api.post("matches/show-interest", {
      student_id: payload.student_id,
      host_id: payload.host_id,
      house_id: payload.house_id,
      message
    });
  }
  updateCheckoutDate(
    payload: IUpdateCheckoutDatePayload
  ): Promise<IResponseShort> {
    return this.api.post("matches/change-checkout-date", payload);
  }

  // Reviews:
  createReview(
    payload: Pick<TReview, "rating" | "review_text" | "house_id">,
    host_id: string
  ): Promise<TReview> {
    return this.api.post("reviews/" + host_id, payload);
  }
  updateReview(
    payload: Partial<TBaseReview> & { created_at: string },
    host_id: string
  ): Promise<IResponseShort> {
    return this.api.patch("reviews/" + host_id, payload);
  }

  // Searches:
  getSearches(userId: string): Promise<ISavedSearchPreference[]> {
    return this.api.get(`users/student/${userId}/search-preference`);
  }
  saveSearchPreference(
    payload: ISearchPreferencePayload,
    userId?: string
  ): Promise<ISavedSearchPreference> {
    return this.api.post(`users/student/${userId}/search-preference`, payload);
  }
  updateSearchPreference(
    created_at: string,
    payload: Partial<ISearchPreferencePayload>,
    userId?: string
  ): Promise<ISavedSearchPreference> {
    return this.api.patch(
      `users/student/${userId}/search-preference?` +
        query.stringify({ created_at }),
      payload
    );
  }
  deleteSearchPreference(
    created_at: string,
    userId?: string
  ): Promise<IResponseShort> {
    return this.api.del(
      `users/student/${userId}/search-preference?` +
        query.stringify({ created_at })
    );
  }

  // Stripe:
  createPaymentIntent(): Promise<{ client_secret: string }> {
    return this.api.post(`payments/create-payment-intent`);
  }
  getPaymentStatus(
    paymentId: string
  ): Promise<{ status: PaymentStatusStripe }> {
    return this.api.get(`payments/get-payment-status/${paymentId}`);
  }
}

export const StudentAPI = new StudentAPIClass();
